<template>
   <v-dialog
      v-model="dialog"
      max-width="100vh"
      @keydown.esc="cancel()"
      @click:outside="cancel()"
   >
      <v-card>
        <v-toolbar dark color="primary" dense flat>
            <v-toolbar-title class="white--text">{{ $t('UPDATE_MAIL_TO_ACTIVATE') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text
         class="secondary--text pa-4 pb-8 font-weight-bold"
        >
         <v-form ref="forgot">
            <v-radio-group ref="chooseNationality" v-model="cardType" height="10" row @change="reset(false);getNationalities()">
                <v-radio
                   :label="$t('NID')"
                   color="primary"
                   :value="1"
                ></v-radio>
                <v-radio
                   :label="$t('PASSPORT')"
                   color="primary"
                   :value="2"
                ></v-radio>
              </v-radio-group>
              <v-text-field
               v-if="cardType === 1"
               append-icon="mdi-earth"
               :placeholder="$t('UserData.NATIONALITY')"
               required
               outlined
               color="primary"
               dense
               disabled
               :value="serverTranslate('مصر|Egypt')"
              ></v-text-field>
              <v-autocomplete
                v-show="cardType === 2"
                append-icon="mdi-earth"
                :rules="nationalityRules"
                :items="serverTranslateArray(nationalities, 'name')"
                item-text="name"
                item-value="id"
                outlined
                dense
                required
                v-model="nationality"
                validate-on-blur
                ref="nationality"
                name="nationality"
                :label="$t('UserData.NATIONALITY')"
              ></v-autocomplete>
              <v-text-field
                append-icon="mdi-card-account-details-outline"
                v-model="cardID"
                :rules="cardType === 1 ? NIDRulse : passportRulse"
                :label="cardType === 1 ? $t('RE_ENTER_NID') : $t('PASSPORT')"
                :maxlength="cardType === 1 ? 14 : 25"
                :counter="cardType === 1 ? 14 : 25"
                required
                outlined
                color="primary"
                dense
                ref="nID"
                @keydown.space="preventLeadingSpace"
              ></v-text-field>
              <v-text-field
               append-icon="mdi-at"
               :label="$t('RE_ENTER_EMAIL')"
               required
               outlined
               color="primary"
               dense
               @keydown.space="preventLeadingSpace"
               v-model="email"
               ref="email"
               :rules="emailRules"
              ></v-text-field>
           </v-form>
        </v-card-text>
        <v-card-actions class="pt-0">
         <v-spacer></v-spacer>
         <v-btn color="primary" @click.native="sendActivation">{{ $t("SEND_ACTIVATION_CODE") }}</v-btn>
         <v-btn color="error" @click.native="cancel()">{{ $t("CANCEL") }}</v-btn>
        </v-card-actions>
      </v-card>
      <ad-confirmDialogCancel ref="confirmCancel"></ad-confirmDialogCancel>
   </v-dialog>
</template>
<script>
   import generalFunctions from "@/mixins/generalFunctions";
   import serverTranslationsMixin from "@/mixins/serverTranslations.js";
   import ConfirmDialog from "@/components/shared/ConfirmDialog";
   export default {
     name: "ad-confirmDialog",
     mixins: [serverTranslationsMixin, generalFunctions],
     components: {
        "ad-confirmDialogCancel": ConfirmDialog
     },
     mounted() {
        this.getNationalities()
     },
     data() {
       return {
           dialog: false,
           resolve: null,
           reject: null,
           cardType:1,
           cardID:"",
           email:"",
           nationality:{},
           nationalities:[],
           nationalityRules:[
             this.$store.state.rules.required,
          ],
          NIDRulse: this.$store.state.rules.NIDRulse,
          passportRulse: this.$store.state.rules.passportRulse,
          emailRules: this.$store.state.rules.emailRules
        }
     },
     methods:{
        open() {
          this.dialog = true;
          return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
          });
        },
        getNationalities() {
           const hasEgypt = 0
           const data = {"hasEgypt":hasEgypt}
              this.$http.post("/api/regions_data/get_countries/", data)
             .then(
                res => {
                   if (res) {
                      this.nationalities = res.data.data
                   }
                }
                ,err => {
                   this.$toasted.show(
                     this.serverTranslate(err.response.data.message),
                     {
                       type: "error",
                       icon: "error_outline",
                       theme: "bubble",
                       position: "bottom-left",
                       duration: 3000
                     }
                   );
                }
             )
        },
        sendActivation() {
           const data = {
             cardType:this.cardType,
             cardID:this.cardID,
             email:this.email,
             nationality:this.nationality,
          }
          if (this.$refs.forgot.validate()) {
              this.$http.post("/api/users/send_activation/", data)
              .then(
                res => {
                   this.dialog = false
                   this.$toasted.show(this.serverTranslate(res.data.message), {
                    type: "success",
                    icon: "check_circle_outline",
                    duration: 3000,
                    theme: "bubble",
                    position: "bottom-left"
                  });
                  this.reset(true)
                },
                err => {
                   this.$toasted.show(
                    this.serverTranslate(err.response.data.message),
                    {
                      type: "error",
                      icon: "error_outline",
                      theme: "bubble",
                      position: "bottom-left",
                      duration: 3000
                    }
                  );
                }
             )
          }
       },
       reset(changeRadio) {
          this.$refs.nationality.reset()
          this.$refs.nID.reset()
          this.$refs.email.reset()
          this.cardID = ""
          this.email = ""
          this.nationality = {}
          if(changeRadio) {
             this.cardType = 1
          }
       },
       cancel() {
          this.$refs.confirmCancel
         .open("CONFIRMATION_MESSAGE", "CONFIRM_CANCEL")
         .then(confirm => {
            if (confirm) {
               this.dialog = false
               this.reset(true)
            }
         })
       }
     }
   }
</script>
